import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import type { IODataEntityDescriptor } from "../declarations/ODataExplorer";
import React from "react";

interface IOrderByControlProps {
    descending: boolean;
    entity: IODataEntityDescriptor;
    onChange: (property: string, descending: boolean) => void;
    property: string;
}

export default function OrderByControl({
    descending,
    entity,
    onChange,
    property,
}: IOrderByControlProps) {
    return (
        <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
            <TextField
                label="$orderby"
                onChange={(e) => onChange(e.target.value, descending)}
                select
                sx={{ minWidth: 220 }}
                value={property}
                size="small"
            >
                <MenuItem value="">(none)</MenuItem>
                {entity.properties
                    .filter((p) => p.isSortable !== false)
                    .map((p) => (
                        <MenuItem key={p.name} value={p.name}>
                            {p.name}
                        </MenuItem>
                    ))}
            </TextField>
            <ToggleButtonGroup
                exclusive
                onChange={(_, v) =>
                    v != null && onChange(property, v === "desc")
                }
                size="small"
                value={descending ? "desc" : "asc"}
            >
                <ToggleButton value="asc">asc</ToggleButton>
                <ToggleButton value="desc">desc</ToggleButton>
            </ToggleButtonGroup>
        </Stack>
    );
}
